/* eslint-disable*/
import './polyfills.js';
import React from "react";
import * as ReactDOMClient from 'react-dom/client';

import "./base.css";
import "./graph.css";
import "./styles.css"
import "./styles-old.css"

import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from '@apollo/client/react';
import { MsalProvider, useMsal } from "@azure/msal-react";
import { PublicClientApplication, EventType, InteractionRequiredAuthError } from "@azure/msal-browser";
import App from "./App";
import { appf_tenant_info, getNewApolloClient, poolData } from "./UserPool";
import { AuthProvider } from "./useAuth";
import { getGraphqlUrl, gData } from "./components/commons";

/* A deploy renames every code-split chunk. A tab opened before it still asks
   for the old names, the server answers with index.html, and the lazy route
   fails to load ("Failed to fetch dynamically imported module", MIME type
   "text/html") - the page goes blank on the next navigation. Vite reports that
   as vite:preloadError; reloading picks up the new build and the navigation
   goes through. At most one reload a minute, so a real outage (the chunks are
   missing for good, or the network is down) shows its error instead of
   reloading in a loop. */
const CHUNK_RELOAD_KEY = "appf.chunkReloadAt";
window.addEventListener("vite:preloadError", (event) => {
  let last = 0;
  try { last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0; } catch (e) { /* storage blocked */ }
  if (Date.now() - last < 60000) return;
  try { sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now())); } catch (e) { /* storage blocked */ }
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById("root");
const root = ReactDOMClient.createRoot(rootElement);

const tenantData = localStorage.getItem("tenantData");
gData.tenantData = tenantData ? JSON.parse(tenantData) : {};
if(typeof appf_tenant_info.sku != "undefined" ){
  gData.tenantData.sku= appf_tenant_info.sku;
}

const client = getNewApolloClient(tenantData != null ? getGraphqlUrl(JSON.parse(tenantData).envURL) : getGraphqlUrl(), poolData)
const clientAssessment = getNewApolloClient((tenantData != null ? getGraphqlUrl(JSON.parse(tenantData).envURL) : getGraphqlUrl()).replaceAll("graphql", "assessments/graphql"), poolData, true)

let msalInstance = {}

if (appf_tenant_info._ !== 'undefined' && appf_tenant_info.type == "azure") {

  const msalConfig = {
    auth: {
      clientId: appf_tenant_info.client_id,
      authority: appf_tenant_info.authority,
      redirectUri: appf_tenant_info.redirectUri,
      postLogoutRedirectUri: '/',
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    }
  };

  msalInstance = new PublicClientApplication(msalConfig);

  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
  }

  const azureRefreshToken = async () => {
    try {
      const currentAccount = msalInstance.getAccountByUsername(msalInstance.getActiveAccount().username);

      var request = {
        scopes: [`${appf_tenant_info.client_id}/user.read`],
        account: currentAccount,
        forceRefresh: true,
        refreshTokenExpirationOffsetSeconds: 7200 // 2 hours * 60 minutes * 60 seconds = 7200 seconds
      };

      const tokenResponse = await msalInstance.acquireTokenSilent(request).catch(async (error) => {
        if (error instanceof InteractionRequiredAuthError) {
          await msalInstance.acquireTokenPopup(request).catch(error => {
            if (error instanceof InteractionRequiredAuthError) {
              // fallback to interaction when silent call fails
              return msalInstance.acquireTokenRedirect(request)
            }
          });
        }
      });

      // recreate appolo client
      poolData.accessToken = tokenResponse.accessToken;
      localStorage.accessToken = tokenResponse.accessToken;

      return poolData.accessToken

    } catch (e) {
      // console.log(e)
    }


  }

  msalInstance.addEventCallback(async (event) => {
    if (event.eventType === EventType.INITIALIZE_END) {
      azureRefreshToken()
      appf_tenant_info.azureRefreshToken = azureRefreshToken;

    } else if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  })
}

const MSContent = (props) => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  return (
    <App instance={props.instance} activeAccount={activeAccount} clientAssessment={props.clientAssessment} />
  );
};

const AppMS = ({ instance, clientAssessment }) => {
  return (
    <MsalProvider instance={instance}>
      <MSContent instance={instance} clientAssessment={clientAssessment} />
    </MsalProvider>
  );
};

root.render(appf_tenant_info.type != "azure" ?
  <Router 
  future={{ 
    v7_relativeSplatPath:true,
    v7_startTransition: true }} 
  >
    <AuthProvider>
      <ApolloProvider client={client} >
        <App clientAssessment={clientAssessment} />
      </ApolloProvider>
    </AuthProvider>
  </Router> :

  <Router>
    <AuthProvider>
      <ApolloProvider client={client} >
        <AppMS instance={msalInstance} clientAssessment={clientAssessment} />
      </ApolloProvider>
    </AuthProvider>
  </Router>
);